<script setup lang="ts">
import ButtonThemeLocal from '@/components/main/ButtonThemeLocal.vue'
import SpinerLoader from '@/components/main/SpinerLoader.vue'
import { dataLoaded } from '@/event/dataLoaded'
import { isOtherThemeHappy, isThemeDefault, isThemeHappy } from '@/event/theme/theme'
import { showSelectedModalProductHappy } from '@/happyTheme/event/product/showSelectedModalProductHappy'
import { defineAsyncComponent, watch } from 'vue'

const Error = defineAsyncComponent(() => import('@/components/error/Error.vue'))

watch(
    () => showSelectedModalProductHappy.value,
    (isVisible) => {
        if (!isVisible) {
            const html = document.documentElement
            if (html.classList.contains('modal-open')) {
                html.classList.remove('modal-open')
            }
        }
    }
)
</script>

<template>
    <section
        class="w-full flex items-center justify-center relative"
        :class="{ 'mt-8': isThemeDefault, 'mt-4': isThemeHappy || isOtherThemeHappy }"
    >
        <ButtonThemeLocal />

        <RouterView v-if="dataLoaded == 2" class="router-view-class" />

        <Error v-else-if="dataLoaded == 1" />
        <SpinerLoader v-else />
    </section>
</template>

<style scoped>
.router-view-class {
    @apply min-w-full;
}

.overlay-section-product-happy {
    @apply fixed top-0 w-screen h-screen transition-opacity duration-300 bg-text-dark-happy-light opacity-70;
}

@media screen and (min-width: 1030px) {
    .router-view-class {
        @apply min-w-[60rem] w-[61rem];
    }
}

@media screen and (min-width: 1280px) {
    .router-view-class {
        @apply min-w-[65rem] w-[66rem];
    }
}

@media screen and (min-width: 1500px) {
    .router-view-class {
        @apply min-w-[75rem] w-[75rem];
    }
}

@media screen and (min-width: 2000px) {
    .router-view-class {
        @apply min-w-[80rem] w-[80rem];
    }
}
</style>
